import * as TYPES from '../types';

const initialState = {
    krList: [],
};

export function KnowledgeRepositoryReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_K_REPO_SUCCESS:
            return {
                ...preState,
                krList: payload,
            };

        default:
            return state;
    }
}